import React, { FC, ReactNode, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';
import Image from '../image';

interface IResultProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 自定义图片
   */
  image?: string;
  /**
   * 类型
   * @default empty
   */
  type?: 'empty' | 'error';
  /**
   * 描述文字
   */
  desc?: ReactNode;
}

const IMAGES = {
  empty: 'https://static.vdfor.top/taro-ink/library/empty.png',
  error: 'https://static.vdfor.top/taro-ink/library/error.png',
};

const Result: FC<PropsWithChildren<IResultProps>> = ({ className, type = 'empty', image, desc, children }) => {
  const rootClass = classNames('ink-result', className);
  return (
    <View className={rootClass}>
      <Image className="ink-result__image" src={image || IMAGES[type]} />
      {desc && <View className="ink-result__desc">{desc}</View>}
      {children}
    </View>
  );
};

export default Result;
